import "./NavExpandIcon.scss";

export const NavExpandIcon = () => {
  return (
    <svg
      className="NavExpandIcon"
      width="20"
      height="20"
      viewBox="2 3 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 16.5L13.75 11L8 5.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
